
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { ProductionTechnicianArea } from '../../../../core/enums/production-technician-area';

export interface MachineSetDefaultPerformanceAreaDialogOption {
  value: ProductionTechnicianArea;
  label: string;
}

export interface MachineSetDefaultPerformanceAreaDialogData {
  options: MachineSetDefaultPerformanceAreaDialogOption[];
  currentArea: ProductionTechnicianArea | null;
}

@Component({
  selector: 'app-machine-set-default-performance-area-dialog',
  imports: [MatDialogModule, MatButtonModule, MatRadioModule],
  templateUrl: './machine-set-default-performance-area-dialog.component.html',
  styleUrl: './machine-set-default-performance-area-dialog.component.scss'
})
export class MachineSetDefaultPerformanceAreaDialogComponent {

  public selectedArea: ProductionTechnicianArea | null;

  constructor(
    private readonly dialogRef: MatDialogRef<MachineSetDefaultPerformanceAreaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: MachineSetDefaultPerformanceAreaDialogData
  ) {
    this.selectedArea = data.currentArea ?? data.options[0]?.value ?? null;
  }

  public onSelectionChange(event: MatRadioChange): void {
    this.selectedArea = event.value as ProductionTechnicianArea;
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public confirm(): void {
    if (this.selectedArea === null) {
      return;
    }

    this.dialogRef.close(this.selectedArea);
  }

}
